import React from 'react';
import PropTypes from 'prop-types';
import {GlossaryErrorState} from '@learningblocks/shared-components';
import {GlossaryDetailsLoader} from '@learningblocks/shared-components';
import style from './style.module.scss';
/**
 * ContentsWrap
 *  - A wrapper for Tooltip contents
 */
export function ContentsWrap(props) {
  const onRetry = (event) => {
    event.preventDefault();
    event.stopPropagation();
    props.onRetry();
  };

  const renderErrorAndLoadingStates = () => {
    if (props.error) {
      return (
        <GlossaryErrorState
          className={style.tooltipErrorState}
          onRetry={onRetry}
        />
      );
    } else {
      return <GlossaryDetailsLoader />;
    }
  };

  if (props.loading === false && props.error === false) {
    return props.children;
  } else {
    return (
      <div className={style.tooltipLoadingState}>
        {renderErrorAndLoadingStates()}
      </div>
    );
  }
}

ContentsWrap.propTypes = {
  /**
   * Boolean specifying contentApi loading
   */
  loading: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.bool]),
  /**
   * Boolean specifying contentApi error
   */
  error: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.bool]),
  /**
   * The elements to display on the tooltip
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  /**
   * Function to execute when retry button is clicked
   */
  onRetry: PropTypes.func.isRequired,
};

ContentsWrap.defaultProps = {
  loading: false,
  error: false,
};
